import AvailabilityFetchVM from '../Types/AvailabilityFetchTSVM';
import appTranslations from "@Components/ArrivalDeparturePicker/Translations/VueTranslations"

const fetchAvailabilityUrl = "/Fetch/FetchAvailability";

export default async function fetchAvailability(accommodationId: number) {

   
    const url = new URL(fetchAvailabilityUrl + `?accommodationId=${accommodationId}`, window.location.href);

    const response = await fetch(url.toString(), {

        method: "Get",
        headers: { 'Content-Type': 'application/json' },
        redirect: "error"

    });

    if (response.ok) {

        return await response.json() as AvailabilityFetchVM;

    } else {

        alert(appTranslations.arrivalDeparturePicker_Error_SomethingWentWrong);

    }

}